import React, { useEffect } from 'react';
import { Box, Typography, Grid, Link } from '@mui/material';
import colorConfigs from '../../../configs/colorConfigs';
import { typo } from '../../../assets/fonts/font';
import assets from '../../../assets';
import ContactForm from '../../common/ContactForm/ContactForm';
import LinkedInInsight from '../../common/LinkedInInsight/LinkedInInsight';

const SmartFridgePage: React.FC = () => {

  useEffect(() => {
    // Suppress specific ResizeObserver errors
    const resizeHandler = () => {};
    
    // Create a ResizeObserver that does nothing
    const resizeObserver = new ResizeObserver(resizeHandler);

    // Optionally, disconnect on unmount
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  
  return (
    <>
      <LinkedInInsight />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          background: colorConfigs.secondary,
          paddingY: 3,
        }}
      >
        <Box
          sx={{
            maxWidth: '1200px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: colorConfigs.secondary,
            justifyContent: 'center',
            margin: 'auto',
            padding: { xs: '0', sm: '2rem', md: '0rem' },
          }}
        >
          <Box sx={{ textAlign: 'center', marginBottom: 6 }}>
            <Typography variant="h4" sx={{ ...typo.smartFridge , fontSize: {
                      xs: '14px',
                      sm: '20px',
                    },}}>
              Delicious & affordable ready-to-eat food at your reach
            </Typography>
            <Typography variant="h4" sx={{ ...typo.smartFridge, fontSize: {
                      xs: '14px',
                      sm: '20px',
                    }, }}>
              without ever leaving your office? Sounds amazing.
            </Typography>
            <Typography variant="h5" sx={{ ...typo.smartFridge, marginTop: 2, fontSize: {
                      xs: '14px',
                      sm: '20px',
                    }, }}>
              Introducing
            </Typography>

            <Grid
              container
              alignItems="center"
              justifyContent="center"
              sx={{
                gap: { xs: 1, sm: 1.2, md: 2, lg: 3 },
                px: { xs: 1, sm: 2, md: 3 },
              }}
            >            
              <Grid item xs={4.4} sm={5} sx={{ textAlign: 'right' }}>
              <Box
                component="img"
                src={assets.images.logo}
                alt="Nomzy Logo"
                sx={{
                  width: {
                    xs: '80%', // Smaller width for extra small screens
                    sm: '60%', // Medium width for small screens
                  },
                  maxWidth: '300px', // Add a maxWidth limit to prevent it from getting too large
                  height: 'auto', // Maintain aspect ratio
                }}
              />
              </Grid>
              <Grid item xs={5.6} sm={6}>
                <Typography
                  sx={{
                    ...typo.title,
                    fontSize: {
                      xs: '22px',
                      sm: '42px',
                      md: '72px',
                    },
                    textAlign:'left',
                  }}
                >
                  Smart Fridge
                </Typography>
              </Grid>
            </Grid>

            <Typography 
              sx={{ 
                ...typo.smartFridge,marginBottom:2,
                fontSize: {
                  xs: '12px',
                  sm: '20px',
                },
                
                  }}>
              Your self-service smart fridge, anytime, every day
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                gap: 2,
              }}
              >
            {/* Excited Image */}
            <Box
              component="img"
              src={assets.images.excited}
              alt="Excited"
              sx={{
                maxWidth: { xs: '30%', sm: '15%' }, // Adjust the size based on screen size
                height: 'auto',
                position: 'absolute',
                bottom: { xs: '10%', sm: '-250px', md: '10%' },
                left: { xs: '0%', sm: '15%', md: '22%' },
                transform: 'rotate(-15deg)',
              }}
            />

            <Box
              component="img"
              src={assets.images.smartFridge}
              alt="Smart Fridge"
              sx={{
                maxWidth: { xs: '55%', sm: '40%', md: '31%' },
                height: 'auto',
              }}
            />

            <Box
              component="img"
              src={assets.images.kids}
              alt="Kids"
              sx={{
                maxWidth: { xs: '12%', sm: '8%' },
                height: 'auto',
                position: 'absolute',
                bottom: { xs: '5%', sm: '-250px', md: '5%' },
                right: { xs: '10%', sm: '15%', md: '26%' },
              }}
            />
          </Box>

          </Box>
        </Box>

        <Box
          sx={{
            maxWidth: '800px',
            width: '80%',
            margin: 'auto',
          }}
        >
          <Grid container spacing={2}>
            {[
              assets.images.stickers1,
              assets.images.stickers2,
              assets.images.stickers3,
              assets.images.stickers4,
              assets.images.stickers5,
              assets.images.stickers6,
            ].map((imageSrc, index) => (
              <Grid item xs={6} sm={4} key={index}>
                <Box
                  component="img"
                  src={imageSrc}
                  alt={`Image ${index + 1}`}
                  sx={{
                    width: '100%',
                    height: 'auto',
                  }}
                />
              </Grid>
            ))}
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography sx={{ ...typo.bodyContent, textAlign: 'center', fontSize: '18px' }}>
              *Terms & conditions apply. Please write to{' '}
              <Link href="mailto:hello@nomzy.club" sx={{ fontWeight: 'bold', textDecoration: 'none', color:colorConfigs.tertiary }}>
                hello@nomzy.club
              </Link>{' '}
              to find out more!
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            py: 4,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography sx={{ ...typo.sectionHeadline, fontWeight:'bold', paddingBottom:5}}>
            Here's how it works:{' '}
          </Typography>
          <Grid container spacing={4} sx={{ maxWidth: '1200px' }}>
            <Grid item xs={12} sm={4}>
              <Box sx={{ px: 2, textAlign: 'center' }}>
                <Box sx={{ mb: 2 }}>
                  <img
                    src={assets.images.step1}
                    alt="Left Column"
                    style={{ maxWidth: '90%', borderRadius: '8px' }}
                  />
                </Box>
                <Typography sx={{ ...typo.bodyContent , fontSize:"18px"}}>1.</Typography>
                <Typography sx={{ ...typo.bodyContent , fontSize:"18px"}}>
                  Scan QR code &
                </Typography>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px" }}>
                  sign up as member
                </Typography>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px" }}>
                (It’s free!)
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box sx={{ px: 2, textAlign: 'center' }}>
                <Box sx={{ mb: 2 }}>
                  <img
                    src={assets.images.step2}
                    alt="Center Column"
                    style={{ maxWidth: '90%', borderRadius: '8px' }}
                  />
                </Box>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px" }}>2.</Typography>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px" }}>
                  Scan each item
                </Typography>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px"}}>
                  using the scanner
                </Typography>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px"}}>
                  to add to cart
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box sx={{ px: 2, textAlign: 'center' }}>
                <Box sx={{ mb: 2 }}>
                  <img
                    src={assets.images.step3}
                    alt="Right Column"
                    style={{ maxWidth: '90%', borderRadius: '8px' }}
                  />
                </Box>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px"}}>3.</Typography>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px"}}>
                  Complete payment,
                </Typography>
                <Typography sx={{ ...typo.bodyContent, fontSize:"18px" }}>
                  and you’re good to go!
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box
            sx={{
              backgroundColor: 'var(--color-warning-background)',
              width: '90%',
              maxWidth: '1200px',
              padding: 2,
              borderRadius: 2,
              marginTop: 5,
            }}
          >
            <Typography
              sx={{
                ...typo.bodyContent,
                fontSize:"18px",
                justifyContent: 'center',
                display: 'flex',
                textAlign: 'center',
              }}
            >
              *Min. $5 wallet balance, or credit card linkage is required
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: { xs: 2, sm: 4 },
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{
              width: '100%',
              maxWidth: '1200px',
              display:'contents'
            }}
          >
            {/* Left Image Section */}
            <Grid
              item
              xs={4.5}
              sm={6}
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-end' },
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  maxWidth: { xs: '90%', sm: '80%' },
                  display: 'flex',
                  justifyContent: 'flex-end',
                  height: 'auto',
                }}
              >
                <img
                  src={assets.images.Explorer}
                  alt="Left Column"
                  style={{
                    width: '100%',
                    maxWidth: '300px',
                    height: 'auto',
                    borderRadius: '8px',
                  }}
                />
              </Box>
            </Grid>

            <Grid
              item
              xs={9}
              sm={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginLeft: { xs: 0, sm: 5 },
                alignItems: { xs: 'center', sm: 'flex-start' },
                textAlign: 'center',
              }}
            >
              <Box id="contact-form"
                sx={{
                  backgroundColor: colorConfigs.primary,
                  borderRadius: '25px',
                  padding: { xs: 2, sm: 3 },
                  maxWidth: { xs: '95%', sm: '60%' },
                  height: 'auto',
                }}
              >
                <Typography
                  sx={{
                    ...typo.bodyContent,
                    color: colorConfigs.smartFridgeContactText,
                    fontWeight:'bold',
                    fontSize: { xs: '12px', sm: '22px' },
                    lineHeight: 'normal',
                  }}
                >
                  Interested in having our smart
                </Typography>
                <Typography
                  sx={{
                    ...typo.bodyContent,
                    color: colorConfigs.smartFridgeContactText,
                    fontWeight:'bold',
                    fontSize: { xs: '12px', sm: '22px' },
                    lineHeight: 'normal',
                  }}
                >
                  fridge near you? Get in touch
                </Typography>
                <Typography
                  sx={{
                    ...typo.bodyContent,
                    color: colorConfigs.smartFridgeContactText,
                    fontWeight:'bold',
                    fontSize: { xs: '12px', sm: '22px' },
                    lineHeight: 'normal',
                  }}
                >
                  with us at{' '}
                  <Typography
                    component="a"
                    href="mailto:hello@nomzy.club"
                    sx={{
                      ...typo.title,
                      fontSize: { xs: '12px', sm: '22px' },
                      lineHeight: 'normal',
                      textDecoration: 'underline',
                      color: colorConfigs.smartFridgeContactLink,
                    }}
                  >
                    hello@nomzy.club
                  </Typography>
                  ,
                </Typography>
                <Typography
                  sx={{
                    ...typo.bodyContent,
                    color: colorConfigs.smartFridgeContactText,
                    fontWeight:'bold',
                    fontSize: { xs: '12px', sm: '22px' },
                    lineHeight: 'normal',
                  }}
                >
                  or leave us your contact below!
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>   
        <Box>
          <ContactForm />
      </Box>
    
      </Box>
    </>
  );
};

export default SmartFridgePage;
